export function StatsSnapshotTime({ generatedAt }: { generatedAt: string }) {
  return (
    <p className="text-xs text-slate-400">
      обновлено{" "}
      <time dateTime={generatedAt}>
        {new Date(generatedAt).toLocaleString("ru-RU", {
          timeZone: "Europe/Moscow",
        })}
      </time>{" "}
      (МСК)
    </p>
  );
}
